import React from "react";
import UniflowOptions from "./UniflowOptions.js";
import Charges from "./Charges.js";
import Campaign from "./Campaign.js";
import MsaOptions from "./MsaOptions.js";
import ServiceSelector from "./ServiceSelector.js";
import { connect } from "react-redux";
import style from "./ExtraOptions.module.css";
import {
  customOptionValidationMessages,
  hasCharges,
  skusUnderWarranty,
  hasSelectionsUnderWarranty
} from "../redux/selectors";
import Alerts from "./shared/Alerts";
import { Form } from "react-bootstrap";

function ExtraOptions({
  customOptionValidationMessages,
  hasCharges,
  isMsa,
  isUniflow,
  skusUnderWarranty,
  hasSelectionsUnderWarranty
}) {
  const showServicePack = skusUnderWarranty.length > 0;
  const hasServiceOptions = isUniflow || hasCharges || showServicePack || isMsa;

  return (
    <Form className={style.root}>
      {hasServiceOptions && <h2 className={style.head}>Service Options</h2>}

      <Alerts alerts={customOptionValidationMessages} />

      {
        !isUniflow && (hasCharges || showServicePack)
        ? <ServiceSelector /> : null
      }

      {isMsa ? (
        <>
          <MsaOptions
            hasCharges={hasCharges}
          />
        </>
      ) : (
        <>
          {isUniflow ? <UniflowOptions /> : null}

          {!isUniflow && hasCharges && !hasSelectionsUnderWarranty ? <Charges /> : null}

          <Campaign />
        </>
      )}
    </Form>
  );
}

export default connect(state => ({
  customOptionValidationMessages: customOptionValidationMessages(state),
  hasCharges: hasCharges(state),
  isMsa: state.quote.isMsa,
  skusUnderWarranty: skusUnderWarranty(state),
  hasSelectionsUnderWarranty: hasSelectionsUnderWarranty(state)
}))(ExtraOptions);
